import { useCallback, useMemo } from 'react';
import { dispatcher } from 'dispatcher';
import { prop } from 'ramda';

import { useDeviceSelector } from '@core/js/store/hooks';

import { useDynamicTags } from '@interlayer/js/app/hooks/useDynamicTags';
import { QUERY_PARAMS } from '@interlayer/js/app/hooks/useQueryParam/constants';
import { getIsUserVerified } from '@interlayer/js/app/hooks/user/hooks/useIsUserVerified';
import { useRegistrationSelector } from '@interlayer/js/app/store/hooks/useRegistrationSelector';
import { DYNAMIC_TAG_NAMES } from '@interlayer/js/app/utils/constants';
import { getRefereeCookie } from '@interlayer/js/app/utils/referrer.util';
import { useNavigate } from '@interlayer/js/hooks/navigate';
import { IUserDetails } from '@interlayer/js/hooks/user/store/buzz/types';

export const useRegNavigationAfterLogin = () => {
    const navigate = useNavigate();
    const formFactor = useDeviceSelector(prop('formFactor'));
    const { config: { afterRegistrationAction, btagsLinkConfig } } = useRegistrationSelector();
    const [dTagAfterRegisterUrl = '/'] = useDynamicTags([DYNAMIC_TAG_NAMES[`${formFactor}AfterRegisterUrl`]]);
    const btagLink = useMemo(() => {
        const { custom19: bTagCookie } = getRefereeCookie() as { custom19: string };

        if (!bTagCookie || !btagsLinkConfig?.length) {
            return '';
        }

        return btagsLinkConfig.find((config) => config?.btag === bTagCookie)?.link || '';
    }, [btagsLinkConfig]);

    return useCallback(({ userDetails }: { userDetails?: IUserDetails }, shouldCheck = true) => {
        if (userDetails?.ageVerificationStatus && getIsUserVerified(userDetails.ageVerificationStatus) || !shouldCheck) {
            navigate(
                btagLink || afterRegistrationAction || dTagAfterRegisterUrl,
                null,
                { removeParams: [QUERY_PARAMS.buyaPowaReferFriendMetaData] }
            );
        }

        dispatcher.dispatch('registration:success', {
            username: userDetails?.username,
            userId: userDetails?.userId,
            playerCode: userDetails?.playerCode
        });
    }, [afterRegistrationAction, btagLink, dTagAfterRegisterUrl, navigate]);
};
